export const TITLE_TYPES_AU = {
  FREEHOLD: 5,
};

export const TITLE_TYPES_NZ = {
  FREEHOLD: 15,
};
